import { Component, OnInit, ViewChild,  Output, EventEmitter, Input } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { DateService } from 'src/app/date.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PageSettingsModel, DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { GetPhysicanBO } from '../client-parent.model';
import { takeUntil } from 'rxjs/operators';
import { ColumnChangeBO } from '../../users/users.model';
import { columnWidth } from '../../manage/manage.model';
import { CommonApiService } from 'src/app/commonapiservice';
import { GeneralService } from 'src/app/service/general.service';
@Component({
  selector: 'app-physician',
  templateUrl: './physician.component.html',
  styleUrls: ['./physician.component.scss']
})
export class PhysicianComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  initialPage: PageSettingsModel;
  id: number = 0;
  ColumnPhysicianArray: columnWidth[];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  public filterSettings: object;
  @ViewChild('gridPhysician') public gridPhysician: GridComponent;
  @Input() Physicianinput: string;
  isShowPhysician: boolean = false;
  @Output() EventEmitFromPhysician = new EventEmitter<number>();
  public data: Observable<DataStateChangeEventArgs>;
  getPhysicianList: GetPhysicanBO = new GetPhysicanBO();
  arraycol: any = [];
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  constructor(public general: GeneralService,public CommonAPI: CommonApiService,public dateservice: DateService, public global: GlobalComponent,public toastrService: ToastrService,) {
    this.data = CommonAPI;
  }
  ngOnInit(): void {
    this.getPhysicianFilter();
      this.isShowPhysician = true;
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  }
  getPhysicianFilter() {
    let url ="api/Physician/getPhysicianWholeDataWithFilter"
    let responseData =
    {
      result: "list",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.getPhysicianList, responseData,"");
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.result.forEach(element => {
        element.pharmacyPhone = (element.pharmacyPhone != null && element.pharmacyPhone != "") ? this.general.reconverPhoneGoogleLibhttpsave(element.pharmacyPhone) : null;
        element.pharmacyPhone = (element.pharmacyPhone != null && element.pharmacyPhone != "") ? this.general.reconverPhoneGoogleLibhttpsave(element.pharmacyPhone) : null
      })
      if (data.result.length > 15) {
        this.gridPhysician.height = '500';
      }
      else {
        this.gridPhysician.height = 'auto';
      }
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(
          err.error,
          "error",
        );
      })
  }
  onActionCompletePhysician(args) {
    this.getPhysicianList.currentpageno = this.gridPhysician.pagerModule.pagerObj.currentPage;
    this.getPhysicianList.pageitem = this.gridPhysician.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getPhysicianList.type = args.columnType;
    }
  }
  dataStateChange(state) {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getPhysicianList.orderColumn = state.sorted[0].name;
        this.getPhysicianList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      this.getPhysicianList.value = state.action.currentFilterObject.value.toString();
      this.getPhysicianList.field = state.action.currentFilterObject.field;

      this.getPhysicianList.matchCase = state.action.currentFilterObject.matchCase;
      this.getPhysicianList.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getPhysicianList.field = "id";
        this.getPhysicianList.matchCase = false;
        this.getPhysicianList.operator = "greaterthanorequal";
        this.getPhysicianList.value = "0";
        this.getPhysicianList.type = "number"
      }
    }
    this.getPhysicianFilter();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Physician_Column.Pagesize != state.take) {
          this.arraycol[0].Physician_Column.Pagesize = state.take
        //   this.SaveColumnwidth();
        }
      }
    }
  }

  onResize(args) {
    if (this.ColumnPhysicianArray != undefined && this.ColumnPhysicianArray != null) {
      const column = this.gridPhysician.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnPhysicianArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    //   this.SaveColumnwidth();
    }
  }
//   SaveColumnwidth() {
//     this.arraycol[0].Physician_Column.Columns = this.ColumnPhysicianArray;
//     this.arraycol[0].Physician_Column.Pagesize = this.gridPhysician.pageSettings.pageSize;
  
//     this.columnchange.userid = parseInt(this.global.userID);
//     this.columnchange.column = JSON.stringify(this.arraycol);
//     this.columnchange.id = this.id;
//     let url = "api/ColumnChange/Savewidth?";
//     this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
//       this.getColumnwidth();
//     });
//   }
//   getColumnwidth() {
//     let url = "api/ColumnChange/getwidth?";
//     this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
//       if (data != null && data != undefined) {
//         this.global.globalColumn = data;
//       }
//       this.arraycol = JSON.parse(data.column);
//       this.ColumnPhysicianArray = JSON.parse(data.column)[0].Physician_Column.Columns;
//       let hidecol = JSON.parse(data.column)[0].Physician_Column.HideColumns
//       this.gridPhysician.hideColumns(hidecol);
//       if (data.userid != null && data.agencyId != null) {
//         this.id = data.id;
//       }
//       this.gridPhysician.pageSettings.pageSize = JSON.parse(data.column)[0].Physician_Column.Pagesize
//       this.ColumnPhysicianArray.forEach(element => {
//         if (element.column == 'Clinic Name') {
//           const column = this.gridPhysician.getColumnByField('clinicName');
//           column.width = element.width;
//           this.gridPhysician.refreshHeader();
//         }
//         if (element.column == 'Physican Name') {
//           const column = this.gridPhysician.getColumnByField('physicianName');
//           column.width = element.width;
//           this.gridPhysician.refreshHeader();
//         }
//         if (element.column == 'NPI') {
//           const column = this.gridPhysician.getColumnByField('npi');
//           column.width = element.width;
//           this.gridPhysician.refreshHeader();
//         }
//         if (element.column == 'Physican Phone') {
//           const column = this.gridPhysician.getColumnByField('clinicPhone');
//           column.width = element.width;
//           this.gridPhysician.refreshHeader();
//         }
//         if (element.column == 'Physican Address') {
//           const column = this.gridPhysician.getColumnByField('clinicAddress');
//           column.width = element.width;
//           this.gridPhysician.refreshHeader();
//         }
//       });
//     });
//   }
  showGridColumns() {
    this.gridPhysician.columnChooserModule.openColumnChooser(200, 50);
  }
  isRadioSelected(data) {
    this.EventEmitFromPhysician.emit(data)
    this.isShowPhysician = false;
  }
}
